<template>
  <pt-batch-grant class="pt-batch-grant__withData" :type="type" :statisticeData="statisticeData" ref="form" @submit="submit" :submitLoading="submitLoading"></pt-batch-grant>
</template>

<script>
import PtBatchGrant from './index'
export default {
  name: 'pt-batch-grant__withData',
  components: {
    'pt-batch-grant': PtBatchGrant
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  props: {
    recordMessage: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      records: this.recordMessage,
      statisticeData: {},
      submitLoading: false,
      type: 'ALL'
    }
  },
  methods: {
    submit (data) {
      if (this.form.isShowOldCustomer && this.form.isShowNewCustomer) {
        this.form.fromOld.validate().then(_ => {
          this.form.fromNew.validate().then(_ => {
            this.submitLoading = true
            this.$store.dispatch('bringNewReward', data).then(res => {
              this.submitLoading = false
              this.$message.success('批量发放成功')
              history.go(-1)
            }).catch(err => {
              this.submitLoading = false
              this.$message.error(err || '批量发放失败')
            })
          })
        })
      } else if (this.form.isShowOldCustomer && !this.form.isShowNewCustomer) {
        this.form.fromOld.validate().then(_ => {
          // this.form.fromNew.validate().then(_ => {
          this.submitLoading = true
          this.$store.dispatch('bringNewReward', data).then(res => {
            this.submitLoading = false
            this.$message.success('批量发放成功')
            history.go(-1)
          }).catch(err => {
            this.submitLoading = false
            this.$message.error(err || '批量发放失败')
          })
          // })
        })
      } else if (!this.form.isShowOldCustomer && this.form.isShowNewCustomer) {
        // this.form.fromOld.validate().then(_ => {
        this.form.fromNew.validate().then(_ => {
          this.submitLoading = true
          this.$store.dispatch('bringNewReward', data).then(res => {
            this.submitLoading = false
            this.$message.success('批量发放成功')
            history.go(-1)
          }).catch(err => {
            this.submitLoading = false
            this.$message.error(err || '批量发放失败')
          })
        })
        // })
      }
    },
    bringNewStatistice () {
      let ids = []
      this.records = (this.records && this.records.length ? this.records : JSON.parse(localStorage.records)) || null
      if (this.records && this.records.length > 0) {
        this.records.forEach(item => {
          ids.push(item.id)
        })
        this.$store.dispatch('bringNewStatistice', ids).then(res => {
          this.statisticeData = res
        }).catch(err => {
          this.$message.error(err || '查询发放数据失败')
        })
      }
    }
  },
  created () {
    if (this.records && this.records.length) {
      localStorage.setItem('records', JSON.stringify(this.records))
    }
    this.type = (this.$route.query && this.$route.query.type) || 'ALL'
    this.bringNewStatistice()
  }
}
</script>
